import React from "react";
import ReusableReportFilter from "../../components/ui/ReusableReportFilter";
import { adminReports } from "../../util/http";

export default function DirectorateReportFilter({ setReport }) {
  const token = localStorage.getItem("token");

  async function searchHandler(e) {
    const response = await adminReports(token);
    const filteredItem = response.reports?.filter((el) =>
      el.service?.toLowerCase().includes(e.target.value.trim().toLowerCase())
    );

    setReport(filteredItem);
  }

  async function filterPending() {
    const response = await adminReports(token);
    const filteredItem = response.reports?.filter(
      (el) => el.status?.toLowerCase() === "pending"
    );
    setReport(filteredItem);
  }

  async function filterQueried() {
    const response = await adminReports(token);
    const filteredItem = response.reports?.filter(
      (el) => el.status?.toLowerCase() === "queried"
    );
    setReport(filteredItem);
  }

  async function filterApproved() {
    const response = await adminReports(token);
    const filteredItem = response.reports?.filter(
      (el) => el.status?.toLowerCase() === "approved"
    );
    setReport(filteredItem);
  }
  return (
    <ReusableReportFilter
      searchHandler={searchHandler}
      filterApproved={filterApproved}
      filterQueried={filterQueried}
      filterPending={filterPending}
    />
  );
}
